import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=48e51ce9&"
import script from "./Lead.vue?vue&type=script&lang=js&"
export * from "./Lead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports